import client from "../http-clients/api";
import {
  AnswersStateResponse,
  ExamPreviewResponse,
  ExamStateParams,
  ExamStateResponse,
  ICertificate,
  IExamBackStep,
  IFullResultInput,
  SafeNumber,
  SubmitAnswerResponse,
} from "@types";
import gate from "../gate";
import { CERTIFICATE_LANG } from "enums/certificate";

const examApi = {
  answers: (exam_id: SafeNumber, question_id: SafeNumber) =>
    gate.get<AnswersStateResponse, never, never>({
      client,
      url: `user/exams/${exam_id}/questions/${question_id}/answers`,
    }),
  report: (exam_id: SafeNumber, question_id: SafeNumber, reason: string) =>
    gate.post<
      any,
      never,
      { reason: string; exam_id: SafeNumber; question_id: SafeNumber }
    >({
      client,
      url: `/user/exams/report`,
      params: { reason, exam_id, question_id },
    }),
  retry: (exam_id: SafeNumber) =>
    gate.post<any, never, never>({
      client,
      url: `/user/exams/${exam_id}/retry`,
    }),
  submitAnswer: (
    exam_id: SafeNumber,
    question_id: SafeNumber,
    answer_id: SafeNumber | null
  ) =>
    gate.post<SubmitAnswerResponse, never, { answer_id?: SafeNumber }>({
      client,
      url: `user/exams/${exam_id}/questions/${question_id}/answers`,
      params: answer_id ? { answer_id: answer_id } : {},
    }),
  getOrUpdateState: (exam_id: SafeNumber, params: ExamStateParams = {}) =>
    gate.get<ExamStateResponse, never, ExamStateParams>({
      client,
      url: `/user/exams/${exam_id}`,
      params,
    }),
  getFullResult: (exam_id: SafeNumber) =>
    gate.get<IFullResultInput, never, never>({
      client,
      url: `/user/exams/${exam_id}/result`,
    }),

  getPreCertificate: (exam_id: SafeNumber, lang?: CERTIFICATE_LANG) =>
    gate.get<ICertificate, never, { lang?: CERTIFICATE_LANG }>({
      client,
      url: `/user/exams/${exam_id}/preCertificate`,
      params: { lang },
    }),
  generateCertificate: (exam_id: SafeNumber) =>
    gate.post<ICertificate, never, never>({
      client,
      url: `/user/exams/${exam_id}/certificate/generate`,
    }),
  showCertificate: (certificateId: string, lang: CERTIFICATE_LANG) =>
    gate.get<ICertificate, never, { lang: CERTIFICATE_LANG }>({
      client,
      url: `/user/exams/certificate/show/${certificateId}`,
      params: { lang },
    }),
  backStepExam: (exam_id: number, number: number) =>
    gate.get<IExamBackStep, never, never>({
      client,
      url: `/user/exams/${exam_id}/back/${number}`,
    }),

  adminExamPrivew: (examId: string | number) =>
    gate.get<ExamPreviewResponse, never, never>({
      client,
      url: `/user/exams/${examId}/preview`,
    }),
};

export default examApi;
